import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useSessionStore } from '@/store/useSessionStore';
import { paths } from '@/router/paths';

interface TopbarProps {
  onMenuToggle: () => void;
}

export function Topbar({ onMenuToggle }: TopbarProps) {
  const navigate = useNavigate();
  // const merchantDomain = useSessionStore((state) => state.merchantDomain);
  const redirectToLogout = useSessionStore((state) => state.redirectToLogout);

  return (
    <header className="sticky top-0 z-20 flex h-14 items-center justify-between gap-3 border-b border-line bg-surface/95 px-4 backdrop-blur lg:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          aria-label="Toggle menu"
          onClick={onMenuToggle}
          className="flex h-9 w-9 items-center justify-center rounded-lg text-ink-muted hover:bg-surface-muted lg:hidden"
        >
          ☰
        </button>
        {/* <span className="hidden text-sm font-medium text-ink-muted sm:inline">{merchantDomain}</span> */}
      </div>

      <div className="flex items-center gap-2">
        <Button size="sm" onClick={() => navigate(paths.manualReturn)}>
          + Manual return
        </Button>
        <Button size="sm" variant="ghost" onClick={redirectToLogout}>
          Logout
        </Button>
      </div>
    </header>
  );
}
